import { useTranslation } from "react-i18next";
import DiaryValuesLineChart from "../diary/DiaryValuesLineChart";

const transformMeasurementsToDataSets = (measurements, t) => {
  const transformedData = [];

  measurements?.forEach((measure) => {
    // check iso date format
    /*let measureDate;
    if (/\d{4}-\d{2}-\d{2}/.test(measure.dateTime)) {
      measureDate = new Date(measure.dateTime);
    } else {
      // Datum im Format TT.MM.JJJJ umwandeln
      const dateParts = measure?.dateTime?.split(".");
      measureDate = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);
    }*/
    measure.params?.forEach((param) => {
      const paramName = param?.name;
      const value = parseFloat(param?.value);
      const unit = param?.unit;

      // search for existing entry with same label (paramName)
      let existingEntry = transformedData?.find(
        (entry) => entry?.label === paramName,
      );

      if (!existingEntry) {
        // create new entry if not exists
        existingEntry = {
          label: t(paramName),
          data: [],
          connectPoints: true,
        };

        transformedData?.push(existingEntry);
      }

      // add data to entry
      existingEntry?.data?.push({
        x: measure?.dateTime,
        y: value,
        value: value,
        unit: unit,
      });
    });
  });

  return transformedData;
};

const MeasurementsLineChart = ({
  measurements,
  patientId,
  onCloseDialog,
  showDialog,
}) => {
  const { t } = useTranslation();
  const values = transformMeasurementsToDataSets(measurements, t);

  return (
    <DiaryValuesLineChart
      header={t("measurements_line_chart")}
      values={values}
      showDialog={showDialog}
      onCloseDialog={onCloseDialog}
      patientId={patientId}
    />
  );
};

export default MeasurementsLineChart;
